<template>
  <div>
    <b-modal class="text-center d-flex" id="share" hide-footer>
      <div class="text-center">
        <b-button id="facebook" type="button" class="mt-4 mr-3 social">
          <span>
            <font-awesome-icon
              :icon="{ prefix: 'fab', iconName: 'facebook' }"
              size="2x"
            />
          </span>
        </b-button>
        <b-button id="pinterest" type="button" class="mt-4 mr-3 social">
          <span>
            <font-awesome-icon
              :icon="{ prefix: 'fab', iconName: 'pinterest' }"
              size="2x"
            />
          </span>
        </b-button>
        <b-button id="twitter" type="button" class="mt-4 mr-3 social">
          <span>
            <font-awesome-icon
              :icon="{ prefix: 'fab', iconName: 'twitter' }"
              size="2x"
            />
          </span>
        </b-button>
        <b-button id="reddit" type="button" class="mt-4 mr-3 social">
          <span>
            <font-awesome-icon
              :icon="{ prefix: 'fab', iconName: 'reddit' }"
              size="2x"
            />
          </span>
        </b-button>
        <b-button id="tumblr" type="button" class="mt-4 mr-3 social">
          <span>
            <font-awesome-icon
              :icon="{ prefix: 'fab', iconName: 'tumblr' }"
              size="1x"
            />
          </span>
        </b-button>
        <b-button id="envelope" type="button" class="mt-4 mr-3 social">
          <span>
            <font-awesome-icon
              far
              :icon="['far', 'envelope']"
              size="1x"
              class="primary"
            ></font-awesome-icon>
            <i class="far fa-envelope"></i>
          </span>
        </b-button>
        <b-button id="link" type="button" class="mt-4 mr-3 social">
          <span>
            <font-awesome-icon
              icon="link"
              size="1x"
              class="primary"
            ></font-awesome-icon>
          </span>
        </b-button>
      </div>
      <a class="mt-4 btn outline rounded-pill" href="#" role="button">
        <span>SHARE</span>
      </a>
    </b-modal>
  </div>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
export default {
  name: "Share",
  components: {
    FontAwesomeIcon,
  },
};
</script>
